export default __webpack_public_path__ + "static/media/logo_en.f177cacf.svg";